export default {"src":"__ASTRO_ASSET_IMAGE__Xn0UV5I8__","width":230,"height":375,"format":"png"}